<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-8",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 8,
      // nextPage: '/questionnaire/section1/9',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Prepare_for_pregnancy.png'),
        mainTitle: 'Do you know or use any of the following ovulation monitoring products?',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'LH and related products',
            },{
              text: 'E2G',
            },{
              text: 'PDG',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
  computed:{
    nextPage(){
      const hasLH = this.$store.state.qsData[this.qsNumber].answer.indexOf('LH and related products') !== -1
      const hasPDG = this.$store.state.qsData[this.qsNumber].answer.indexOf('PDG') !== -1
      if(hasLH || hasPDG){
        return '/questionnaire/section1/9'
      }else{
        return '/questionnaire/section2'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
